import { publicFetch } from "./client"
import type { PublicEvent, EventsResponse } from "./types"

export async function getEvents(options?: {
  eventType?: string
  limit?: number
  offset?: number
}): Promise<EventsResponse> {
  try {
    const params = new URLSearchParams()
    if (options?.eventType) params.set("event_type", options.eventType)
    if (options?.limit) params.set("limit", options.limit.toString())
    if (options?.offset) params.set("offset", options.offset.toString())
    const data = await publicFetch<EventsResponse>(`/events?${params.toString()}`)
    return {
      data: data.data || [],
      total: data.total || 0,
      limit: data.limit || 50,
      offset: data.offset || 0,
    }
  } catch (error) {
    console.error("Fetch events error:", error)
    return { data: [], total: 0, limit: 50, offset: 0 }
  }
}

export async function getEvent(eventId: string): Promise<PublicEvent | null> {
  try {
    return await publicFetch<PublicEvent>(`/events/${eventId}`)
  } catch (error) {
    console.error("Fetch event error:", error)
    return null
  }
}
